import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import Dollar from "../../../../images/icons/financial-number-deal.svg";

// Functional component
function RevenueNumberDeal({ clientInvoices }) {
  const [displayedCount, setDisplayedCount] = useState(0);
  const [targetCount, setTargetCount] = useState(0);
  const animationFrameRef = useRef(null);
  const reportingRevenue = useSelector((state) => state.reportingRevenue);

  useEffect(() => {
    if (clientInvoices && reportingRevenue) {
      const filteredInvoices = clientInvoices.filter(invoice => {
        const preferredInvoiceCurrency = invoice?.cli_inv_currency || 'USD';
        const isClientDetailMatch = !reportingRevenue?.revenueClient || reportingRevenue?.revenueClient.includes(invoice?.cli_inv_for?._id);
        const isNotDeleted = !invoice.is_delete;
        const isYearMatch = !reportingRevenue?.revenueYear ||
          new Date(invoice?.cli_inv_created_at).getFullYear() === reportingRevenue?.revenueYear;
        const isCurrencyMatch = reportingRevenue.revenueCurrency && reportingRevenue.revenueCurrency.includes(preferredInvoiceCurrency);
        return isClientDetailMatch && isNotDeleted && isYearMatch && isCurrencyMatch;
      });

      const count = filteredInvoices.length || 0;
      setTargetCount(count);
    } else {
      setTargetCount(0);
    }
  }, [clientInvoices, reportingRevenue]);

  useEffect(() => {
    // Cancel any existing animation
    if (animationFrameRef.current) {
      cancelAnimationFrame(animationFrameRef.current);
    }

    const startValue = displayedCount;
    const endValue = targetCount;
    const duration = 1000; // Animation duration in milliseconds
    const startTime = performance.now();

    const animate = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      
      // Easing function for smooth animation (ease-out)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      
      const currentValue = startValue + (endValue - startValue) * easeOut;
      setDisplayedCount(Math.floor(currentValue));

      if (progress < 1) {
        animationFrameRef.current = requestAnimationFrame(animate);
      } else {
        setDisplayedCount(endValue);
        animationFrameRef.current = null;
      }
    };

    if (Math.abs(startValue - endValue) > 0.01) {
      animationFrameRef.current = requestAnimationFrame(animate);
    }

    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
    };
  }, [targetCount]);

  return (
    <div>
      <div className="overview-item">
        <div className="overview-title-outer">
          <div className="overview-title">
            Number of Invoices
          </div>
          <div className="overview-icon">
            <img src={Dollar} alt="cLock" />
          </div>
        </div>

        <div className="overview-rice">
          {displayedCount}
        </div>
      </div>

    </div>
  );
}

export default RevenueNumberDeal;
